module.exports = __webpack_public_path__ + "img/4.73e90ab6.png";